import { Check } from 'lucide-react';

import { ChatConversation } from '@/hooks/useChat';

import { CommandItem } from '@/components/ui/Command';

interface ConversationGroupItemProps {
  conversation: ChatConversation;
  isActive: boolean;
  onSelect: (id: string) => void;
}

export const ConversationGroupItem = (props: ConversationGroupItemProps) => (
  <CommandItem
    key={props.conversation.id}
    value={props.conversation.id}
    onSelect={() => props.onSelect(props.conversation.id)}
    className="cursor-pointer flex items-center justify-between"
  >
    <span className="truncate flex-1 min-w-0">{props.conversation.title}</span>
    {props.isActive && <Check className="h-4 w-4 ml-3 flex-shrink-0" />}
  </CommandItem>
);
